import ApplicationAction from './ApplicationAction';

export default class ApplicationsActionsLocale {
  [index: string]: { data: ApplicationAction[], loaded: boolean };
}
